angular.module('virtoCommerce.marketplaceModule').controller(
    'virtoCommerce.marketplaceModule.masterCatalogController',
    [
        '$scope', 'virtoCommerce.catalogModule.catalogs', 'virtoCommerce.marketplaceModule.webApi',
        'platformWebApp.bladeNavigationService', 'platformWebApp.uiGridHelper', 'platformWebApp.bladeUtils', '$timeout',
        function ($scope, catalogs, marketplaceWebApi, bladeNavigationService, uiGridHelper, bladeUtils, $timeout) {

            $scope.uiGridConstants = uiGridHelper.uiGridConstants;
            var blade = $scope.blade;
            blade.currentEntities = [];
            var selectedNode = null;

            blade.refresh = function () {
                blade.isLoading = true;

                if ($scope.pageSettings.currentPage !== 1)
                    $scope.pageSettings.currentPage = 1;

                marketplaceWebApi.getSettings((settings) => {
                    catalogs.search(getSearchCriteria([settings.masterCatalogId]), function (data) {
                        blade.isLoading = false;
                        $scope.pageSettings.totalItems = data.totalCount;
                        blade.currentEntities = data.results;

                        if (selectedNode) {
                            //select the node in the new list
                            selectedNode = _.findWhere(data.results, { id: selectedNode.id });
                        }
                    });
                });
                if ($scope.gridApi) {
                    blade.currentEntities = [];
                }
            };

            function getSearchCriteria(ids) {
                return {
                    catalogIds: ids,
                    sort: uiGridHelper.getSortExpression($scope),
                    skip: ($scope.pageSettings.currentPage - 1) * $scope.pageSettings.itemsPerPageCount,
                    take: $scope.pageSettings.itemsPerPageCount
                };
            }

            $scope.selectNode = function (node) {
                selectedNode = node;
                $scope.selectedNodeId = selectedNode.id;

                openItemsBlade(node);

                // setting current catalog to be globally available 
                bladeNavigationService.catalogsSelectedCatalog = selectedNode;
                bladeNavigationService.catalogsSelectedCategoryId = undefined;
            };

            function openItemsBlade(node) {
                var newBlade = {
                    id: 'itemsList1',
                    level: 1,
                    breadcrumbs: blade.breadcrumbs,
                    title: 'catalog.blades.categories-items-list.title',
                    controller: 'virtoCommerce.catalogModule.categoriesItemsListController',
                    template: 'Modules/$(VirtoCommerce.Catalog)/Scripts/blades/categories-items-list.tpl.html'
                };

                if (node.id)
                    angular.extend(newBlade,
                        {
                            subtitle: 'catalog.blades.categories-items-list.subtitle',
                            subtitleValues: { name: node.name },
                            catalogId: node.id,
                            catalog: node,
                            securityScopes: node.securityScopes
                        });
                else
                    angular.extend(newBlade,
                        {
                            filterKeyword: filter.keyword,
                            subtitle: 'catalog.blades.categories-items-list.subtitle-search',
                            subtitleValues: { keyword: filter.keyword }
                        });

                bladeNavigationService.showBlade(newBlade, blade);
            }

            $scope.editCatalog = function (catalog) {
                showCatalogBlade(catalog.id, null, catalog.name);
            };

            function showCatalogBlade(id, data, title) {
                var newBlade = {
                    currentEntityId: id,
                    currentEntity: data,
                    title: title,
                    id: 'catalogEdit',
                    subtitle: 'catalog.blades.catalog-detail.subtitle',
                    controller: 'virtoCommerce.catalogModule.catalogDetailController',
                    template: 'Modules/$(VirtoCommerce.Catalog)/Scripts/blades/catalog-detail.tpl.html',
                };

                bladeNavigationService.showBlade(newBlade, blade);
            }

            blade.toolbarCommands = [
                {
                    name: "platform.commands.refresh",
                    icon: 'fa fa-refresh',
                    executeMethod: blade.refresh,
                    canExecuteMethod: function () {
                        return true;
                    }
                }
            ];

            // simple and advanced filtering
            var filter = blade.filter = { keyword: null };

            filter.criteriaChanged = function () {
                if (filter.keyword) {
                    openItemsBlade({});
                } else
                    bladeNavigationService.closeChildrenBlades(blade);

                selectedNode = null;
                $scope.selectedNodeId = null;
                bladeNavigationService.catalogsSelectedCatalog = undefined;
                bladeNavigationService.catalogsSelectedCategoryId = undefined;
            };

            $scope.setGridOptions = function (gridOptions) {
                bladeUtils.initializePagination($scope, true);
                $scope.pageSettings.itemsPerPageCount = 20;

                uiGridHelper.initialize($scope, gridOptions, function (gridApi) {
                    //update gridApi for current grid
                    $scope.gridApi = gridApi;

                    uiGridHelper.bindRefreshOnSortChanged($scope);

                });

                // need to call refresh after digest cycle as we do not "$watch" for $scope.pageSettings.currentPage
                $timeout(function () {
                    blade.refresh();
                });
            };
        }
    ]
);
